module.exports = __webpack_public_path__ + "static/img/6.bb58259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/doublelift/6.png
// module id = dXTc
// module chunks = 35